// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SafetyOutlinedSvg from "@fishx/icons-svg/es/asn/SafetyOutlined";
import FishxIcon from '../components/FishxIcon';

var SafetyOutlined = function SafetyOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: SafetyOutlinedSvg
  }));
};

SafetyOutlined.displayName = 'SafetyOutlined';
export default React.forwardRef(SafetyOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/SafetyOutlined.js
// module id = 4058
// module chunks = 0